import {css} from 'lit'; export default css`:host a.trial-banner-link{color:var(--goto-type-color-default)!important}chameleon-banner{height:32px;position:absolute;width:100%}`;
    